module.exports = __webpack_public_path__ + "static/media/error.db067a30.png";